var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"product-item-summary"},[_c('router-link',{attrs:{"to":{
      name: 'ProductType',
      params: {
        name: _vm.name,
        type: 'feature',
      },
    }}},[_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(_vm.imagePath),expression:"imagePath"}]})]),_vm._v(" "),_c('div',{staticClass:"summary-appeal"},[_vm._v(_vm._s(_vm.appeal))]),_vm._v(" "),_c('div',{staticClass:"summary-detail"},[_vm._v(_vm._s(_vm.detail))]),_vm._v(" "),_c('div',{staticClass:"summary-footer"},_vm._l((_vm.buttons),function(button,index){return _c('router-link',{key:index,attrs:{"to":{
        name: 'ProductType',
        params: {
          name: _vm.name,
          type: button.type,
        },
      }}},[_vm._v("\n      "+_vm._s(button.name)+"\n    ")])}),1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-19ed9a65","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/ProductItemSummary.vue
// module id = null
// module chunks = 